import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { Button, ButtonToolbar } from 'reactstrap';
import Content from '../../../layout/Content';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import LegalCargoForm from './LegalCargoForm';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';
import {
  clearLegalCargos,
  getLegalCargos,
  getLegalCargosByDocumentNumber,
  postGenerateExcel,
} from '../../../../actions/legal/LegalCargo';
import LegalCargoTableForm from './LegalCargoTableForm';
import LegalCargoSearchByDocumentNumberForm from './LegalCargoSearchByDocumentNumberForm';

const LegalCargos = ({
  breadcrumbs,
  dispatchGetLegalCargos,
  legalCargos,
  loading,
  dispatchClearLegalCargos,
  dispatchPostGenerateExcel,
  dispatchGetLegalCargosByDocumentNumber
}) => {
  useEffect(() => () => dispatchClearLegalCargos(), []);

  const [isSearchByCustomer, setIsSearchByCustomer] = useState(true);

  const searchByDocumentNumber = (formValues) => {
    const { documentSerie, documentCode } = formValues;
    dispatchGetLegalCargosByDocumentNumber({ documentSerie, documentCode });
  }

  const searchByCustomer = (formValues) => {
    const { customer, business, fromDateString, toDateString } = formValues;

    const startDate = tzNormalizeDate({
      date: fromDateString,
      format: INT_DATE_FORMAT,
    });
    const endDate = tzNormalizeDate({
      date: toDateString,
      format: INT_DATE_FORMAT,
    });

    const baseFilters = { startDate, endDate };

    if (customer) {
      baseFilters.customerId = customer.value;
    }
    if (business) {
      baseFilters.businessId = business.value;
    }

    dispatchGetLegalCargos({
      ...baseFilters,
    });
  }

  const onSubmitForm = (formValues) => {
    if (isSearchByCustomer) {
      searchByCustomer(formValues);
      return
    }
    searchByDocumentNumber(formValues);
  };

  const handleSubmit = ({ items }) => {
    dispatchPostGenerateExcel(items)
  }

  const form = isSearchByCustomer ? (
    <LegalCargoForm onSubmit={onSubmitForm} loading={loading} />
  ) : (
    <LegalCargoSearchByDocumentNumberForm onSubmit={onSubmitForm} loading={loading} />
  );

  const content = (
    <>
      {form}
      <h3>Resultados de Búsqueda</h3>
      <LegalCargoTableForm loading={loading} legalCargos={legalCargos} onSubmit={handleSubmit} />
    </>
  );

  const handleToogleSearch = () => {
    setIsSearchByCustomer(!isSearchByCustomer);
  }

  const toolbar = (
    <ButtonToolbar className="pull-right">
      <div>
        <Button
          color="secondary"
          onClick={handleToogleSearch}
        >
          {!isSearchByCustomer ? 'Buscar Por Cliente/Empresa' : 'Buscar por Comprobante'}
        </Button>
      </div>
    </ButtonToolbar>
  )

  return (
    <Content
      title="Carga"
      text="Éste es el módulo de Gestión de Carga."
      breadcrumbs={breadcrumbs}
      content={content}
      toolbar={toolbar}
    />
  );
};

LegalCargos.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchGetLegalCargos: PropTypes.func.isRequired,
  dispatchClearLegalCargos: PropTypes.func.isRequired,
  legalCargos: PropTypes.instanceOf(Immutable.List).isRequired,
  loading: PropTypes.bool,
  dispatchPostGenerateExcel: PropTypes.func.isRequired,
  dispatchGetLegalCargosByDocumentNumber: PropTypes.func.isRequired,
};

LegalCargos.defaultProps = {
  loading: false,
};

const mapStateToProps = ({ LegalUnit }) => ({
  breadcrumbs: [
    ...LegalUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Carga',
      href: '',
    },
  ],
  loading: LegalUnit.LegalCargo.getIn(['all', 'loading']),
  legalCargos: LegalUnit.LegalCargo.getIn(['all', 'content']),
});

const mapDispatchToProps = {
  dispatchGetLegalCargos: getLegalCargos,
  dispatchClearLegalCargos: clearLegalCargos,
  dispatchPostGenerateExcel: postGenerateExcel,
  dispatchGetLegalCargosByDocumentNumber: getLegalCargosByDocumentNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(LegalCargos);
